import { z } from 'zod'

export const personId = z.string().min(1)

export const createPersonInput = z.object({
  name: z.string().trim().min(1).max(120)
})

export type CreatePersonInput = z.infer<typeof createPersonInput>

export const updatePersonInput = z
  .object({
    name: z.string().trim().min(1).max(120).optional(),
    active: z.boolean().optional()
  })
  .refine((input) => Object.keys(input).length > 0, {
    message: 'Provide at least one person field to update.'
  })

export type UpdatePersonInput = z.infer<typeof updatePersonInput>

export const person = z.object({
  id: personId,
  name: z.string().min(1),
  active: z.boolean(),
  createdAt: z.iso.datetime()
})

export type Person = z.infer<typeof person>
